import axios from "axios";
import { Response } from "@/shared/models/Response";
import { SpaceQuery } from "../models/SpaceQuery";
import { SpacePagination } from "../models/SpacePagination";
import { Space } from "../models/Space";
import { CampusSpaceModel } from "@/shared/models/CampusSpaceModel";
import { SpaceHeader } from "../models/SpaceHeader";

export class SpaceService {
  private baseUrl: string;

  constructor() {
    this.baseUrl = `${process.env.VUE_APP_SCHEDULING_API}/space`;
  }

  async getSpaceById(id: string): Promise<Response<Space | void>> {
    const serviceUrl = `${this.baseUrl}/${id}`;
    const response = await axios.get(serviceUrl);
    return response.data;
  }

  async getSpaceByFilter(
    query: SpaceQuery
  ): Promise<Response<SpacePagination>> {
    const serviceURL = `${this.baseUrl}/find-by-filters`;
    const response = await axios.get(serviceURL, { params: query });
    return response.data;
  }

  async getAllSpacesWithFilters(
    query: SpaceQuery
  ): Promise<Response<SpaceHeader[]>> {
    const serviceURL = `${this.baseUrl}/all-spaces`;
    const response = await axios.get(serviceURL, { params: query });
    return response.data;
  }

  async deleteSpace(id: string): Promise<Response<string | void>> {
    return (await axios.delete(`${this.baseUrl}/${id}`)).data;
  }

  async addSpace(space: Space): Promise<Response<string | void>> {
    const serviceUrl = `${this.baseUrl}/`;
    const response = await axios.post(serviceUrl, space);

    return response.data;
  }

  async updateSpace(
    id: string,
    sessionTemplate: Space
  ): Promise<Response<void>> {
    const serviceUrl = `${this.baseUrl}/${id}`;
    const response = await axios.put(serviceUrl, sessionTemplate);
    return response.data;
  }

  async getAllSpaces(): Promise<Response<void | CampusSpaceModel[]>> {
    return (await axios.get(`${this.baseUrl}/`)).data;
  }

  async updateStateSpaceById(
    id: string,
    state: string
  ): Promise<Response<string | void>> {
    const serviceUrl = `${this.baseUrl}/state/${id}/${state}`;
    const response = await axios.put(serviceUrl);
    return response.data;
  }

  async checkIfExistByName(
    name: string,
    campusName?: string
  ): Promise<Response<void>> {
    const serviceURL = `${this.baseUrl}/exist-by-name`;

    const params = {
      params: {
        nameSpace: name,
        campusRef: campusName
      }
    };

    const response = await axios.get(serviceURL, params);
    return response.data;
  }
}
